import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import {
  getLibraryReturnHref,
  getLibrarySearchSnapshot,
  syncLibrarySearchSnapshot,
  type LibrarySection,
} from "@/lib/library-search-snapshot";

export function useLibrarySearchSnapshot(section: LibrarySection) {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const search = location.search;

    if (!search && getLibrarySearchSnapshot(section)) {
      navigate(getLibraryReturnHref(section), { replace: true });
      return;
    }

    syncLibrarySearchSnapshot(section, search);
  }, [section, location.search, navigate]);
}
